(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class announcementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setPromoHeight();
      window.matchMedia('(max-width: 768px)').addEventListener('change', this.setPromoHeight.bind(this));
    }

    setPromoHeight() {
      document.documentElement.style.setProperty('--promo-height', `${this.offsetHeight}px`);
    }
  }

  customElements.define('announcement-bar', announcementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 768px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-bottom-position', `${this.getBoundingClientRect().bottom}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  class ProductAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initAccordions();
    }

    initAccordions() {
      this.querySelectorAll('.product_accordion').forEach(accordion => {
        const title = accordion.querySelector('.product__accordion_title');
        const button = title.querySelector('.product__accordion-trigger');
        const content = accordion.querySelector('.product__accordion_content');
        const isOpen = accordion.classList.contains('open');

        this.setup(button, content, isOpen);

        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');

        if (!button.dataset.accordionBound) {
          const toggleAccordion = () => {
            document.querySelectorAll('.product_accordion').forEach(otherAccordion => {
              if (otherAccordion !== accordion && otherAccordion.classList.contains('open')) {
                const otherButton = otherAccordion.querySelector('.product__accordion-trigger');
                const otherContent = otherAccordion.querySelector('.product__accordion_content');
                otherAccordion.classList.remove('open');
                this.setup(otherButton, otherContent, false);
              }
            });

            const nowOpen = accordion.classList.toggle('open');
            this.setup(button, content, nowOpen);
          };

          title.addEventListener('click', toggleAccordion);
          button.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleAccordion();
            }
          });

          button.dataset.accordionBound = 'true';
        }
      });
    }

    setup(button, content, isOpen) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        content.removeAttribute('inert');
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.setAttribute('inert', '');
        content.style.maxHeight = '0';
      }
    }
  }
  customElements.define('product-accordion', ProductAccordion);

  class howToUsePopup extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {

      const video = this.querySelector('video');
      const videoToggle = this.querySelector('.gallery-video-toggle');
      const videoSeekbar = this.querySelector('.gallery-video-seekbar');
      const volumeToggle = this.querySelector('.gallery-volume-toggle');

      if (!video || !videoToggle || !videoSeekbar || !volumeToggle) return;

      const itemData = { video, videoToggle, videoSeekbar, volumeToggle };
      this.bindEvents(itemData);

      this.startSeekbarLoop(video, videoSeekbar);

      this.closeButton = this.querySelector('.htu-close');

      this.closeButton.addEventListener('click', () => {
        this.close();
      });
    }

    open(opener) {
      this.openedBy = opener;
      this.classList.add('open');
      this.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        trapFocus(this,this.closeButton);
      }, 200);
    }
    
    close() {
      this.querySelector('video').pause();
      this.querySelector('.gallery-video-toggle').textContent = 'Play';
      this.classList.remove('open');
      this.querySelector('.htu-popup-inner').setAttribute('inert', '');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.openedBy);
    }

    bindEvents({ video, videoToggle, videoSeekbar, volumeToggle }) {
      videoToggle.addEventListener('click', () => this.togglePlayback(video, videoToggle));
      video.addEventListener('ended', () => this.resetPlaybackButton(videoToggle));

      videoSeekbar.addEventListener('input', () =>
        this.seekVideo(video, videoSeekbar)
      );

      volumeToggle.addEventListener('click', () => {
        video.muted = !video.muted;
        volumeToggle.classList.toggle('muted', video.muted);
      });
    }

    togglePlayback(video, button) {
      if (video.paused || video.ended) {
        video.play();
        button.textContent = 'Pause';
      } else {
        video.pause();
        button.textContent = 'Play';
      }
    }

    resetPlaybackButton(button) {
      button.textContent = 'Play';
    }

    seekVideo(video, seekbar) {
      const time = (seekbar.value / 100) * video.duration;
      video.currentTime = time;
      this.updateSeekbar(video, seekbar);
    }

    updateSeekbar(video, seekbar) {
      const progress = (video.currentTime / video.duration) * 100;
      seekbar.value = progress;
      seekbar.style.setProperty('--progress', `${progress}%`);
    }

    pauseVideo(video, button) {
      if (!video.paused) {
        video.pause();
        button.textContent = 'Play';
      }      
    }

    startSeekbarLoop(video, videoSeekbar) {
      const loop = () => {
        if (!video.paused && !video.ended) {
          this.updateSeekbar(video, videoSeekbar);
        }
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }
  }
  customElements.define("how-to-use-popup", howToUsePopup);

  class sideDrawerOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const drawer = document.querySelector(this.getAttribute('data-modal'));
        if (drawer) drawer.open(button);
      });
    }
  }
  customElements.define('side-drawer-opener', sideDrawerOpener);

  class sideDrawer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.closeButton = this.querySelector('.side-drawer-close');
      this.showSectionButton = this.querySelector('.side-drawer-cta button');

      this.closeButton.addEventListener('click', () => {
        this.close();
      });

      this.addEventListener('click', (event) => {
        this.handleClickOutside(event);
      });

      this.showSectionButton?.addEventListener('click', () => {
        const sectionId = this.showSectionButton.getAttribute('data-section-id');
        const section = document.querySelector(sectionId);
        if (section) {
          this.close();
          section.scrollIntoView({ behavior: 'smooth' });
          var elements = getFocusableElements(section);
          var first = elements[0];
          if (first) {
          setTimeout(() => {
              first.focus({ preventScroll: true });
            }, 500);
          }
        }
      });
    }

    open(opener) {
      this.openedBy = opener;
      this.classList.add('open');
      this.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        trapFocus(this,this.closeButton);
      }, 100);
    }
    
    close() {
      this.classList.remove('open');
      this.setAttribute('inert', '');
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.openedBy);
    }

    handleClickOutside(event) {
      if (event.target === this) {
        this.close();
      }
    }
  }
  customElements.define("side-drawer", sideDrawer);

  class stickyAtc extends HTMLElement {
    connectedCallback() {
      this.isMobile = window.innerWidth < 769;
      this.visibilityMap = new Map();
      this.closeButton = this.querySelector('.sticky-atc-close');

      this.initTargets();
      if (!this.targets.length) return;

      this.observeTargets();
      // if (this.isMobile) this.bindScrollTrigger();

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
    }

    close() {
      this.classList.remove('fixed');
      if (this.observer && this.targets) {
        this.targets.forEach(target => this.observer.unobserve(target));
      }
      this.visibilityMap.clear();
    }

    initTargets() {
      const selectors = this.isMobile
        ? ['.product__description', '.buy_buttons_flex', '.product__media-wrapper']
        : ['.product__description', '.buy_buttons_flex'];

      this.targets = selectors
        .map(sel => document.querySelector(sel))
        .filter(Boolean);
    }

    observeTargets() {
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue("--header-height").trim();
      // const observer = new IntersectionObserver(this.handleIntersect.bind(this));
      const observer = new IntersectionObserver(
        this.handleIntersect.bind(this),
        {
          rootMargin: `-${headerHeight} 0px 0px 0px`,
        }
      );
      this.targets.forEach(target => {
        this.visibilityMap.set(target, true); // assume visible
        observer.observe(target);
      });
    }

    handleIntersect(entries) {
      entries.forEach(entry => {
        this.visibilityMap.set(entry.target, entry.isIntersecting);
      });

      const anyVisible = Array.from(this.visibilityMap.values()).some(Boolean);
      this.classList.toggle('fixed', !anyVisible);
    }

    bindScrollTrigger() {
      const trigger = this.querySelector('.sticky-atc-flex');
      const scrollTarget = document.querySelector('.buy_buttons_flex');

      if (trigger && scrollTarget) {
        trigger.addEventListener('click', () => {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }
  customElements.define('sticky-atc', stickyAtc);

  document.addEventListener("DOMContentLoaded", () => {
    const currentSectionElement = document.querySelector(".installment_form");
    if (!currentSectionElement) return;
    // Create a MutationObserver to watch for the form-embed element being added to the DOM
    const termsElement = currentSectionElement.querySelector("shopify-payment-terms");
    if (termsElement) {
      // Disconnect this specific observer instance
      const shadow = termsElement.shadowRoot;
      if (shadow) {
        const styleEl = document.createElement("style");
        styleEl.textContent = `
          * {
            font-family: var(--font-family-body-2);
          }
          .font-bold {
            font-weight: 500 !mportant;
          }
          svg path{
            fill: #000;
          }
          [aria-haspopup="dialog"]{
            color: rgba(var(--color-black),.5);
            font-weight: 500;
            font-style: italic;
            width: 6.2rem;
            white-space: nowrap;
          }
          [aria-haspopup="dialog"]:hover {
            color: rgb(var(--_color-primary, var(--color-primary)));
          }
        `;
        shadow.appendChild(styleEl);
      }
      currentSectionElement.classList.add("loaded");
    }
    const shopPopup = document.querySelector("[data-nametag='shop-portal-provider']");
    if (shopPopup) {
      const shadowShop = shopPopup.shadowRoot;
      if (shadowShop) {
        const styleEl = document.createElement("style");
        styleEl.textContent = `
          [data-testid="split-pay-subtitle"]{
            font-family: var(--font-family-body-1) !important;
            font-size: 1.6rem !important;
          }
          #eligibility-approval{
            letter-spacing: 0 !important;
            font-family: var(--font-family-body-2) !important;
            font-weight: var(--font-weight-body-2) !important;
            font-style: var(--font-style-body-2) !important;
            font-size: var(--font-size-body-2-desktop) !important;
            line-height: var(--line-height-body-2-desktop) !important;
          }
          [data-testid="split-pay-content"] li{
            font-family: var(--font-family-body-2) !important;
            font-size: 1.6rem !important;
          }
          .text-body-large{
            font-family: var(--font-family-heading-3) !important;
            font-weight: var(--font-weight-heading-3) !important;
            font-style: var(--font-style-heading-3) !important;
            font-size: var(--font-size-heading-3-desktop) !important;
            line-height: var(--line-height-heading-3-desktop) !important;
            letter-spacing: var(--letter-spacing-heading-3) !important;
          }
        `;
        shadowShop.appendChild(styleEl);
      }
      currentSectionElement.classList.add("loaded");
    }
  });

  } catch(e) { console.error(e); }
})();
})();
